import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {VehicleBrand} from '../../shared/models/vehicle-brand';
import {LegalEntity} from '../../shared/models/legal-entity';

@Component({
  selector: 'toycc-dsi-footer',
  imports: [
    NgClass
  ],
  templateUrl: './dsi-footer.component.html'
})
export class DsiFooterComponent {
  @Input() brand: VehicleBrand;
  @Input() legalEntity: LegalEntity;
  showContactInfoMobile = false;

  toggleContactInfoMobile() {
    this.showContactInfoMobile = !this.showContactInfoMobile;
    if (this.showContactInfoMobile) {
      setTimeout(() => {
        window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
      });
    }
  }
}
